module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        trackingNumber: {
            type: 'string'
        },
        carrier: {
            type: 'string'
        }
    }
};